<template>
    <section class="user-skills">
      <b-modal
        v-model="editSkills.showModal"
        size="md"
        :style="{ zIndex: 200 }"
        no-close-on-backdrop
      >
        <preloader v-show="loading"/>
        <template v-slot:modal-header="{ cancel }">
          <h5 class="modal-title">Update skills</h5>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click.prevent="cancel"
          >
            <span class="material-icons">
              close
            </span>
          </button>
        </template>
        <div>
          <div class="table_theme-info">
            <b-table
              class="mb-0 pb-0"
              hover
              :items="userSkills"
              :fields="fieldsSkill"
              fixed
            >
              <template v-slot:cell(value)="data">
                <b-form
                  v-if="$can('update_all-skills') || $can('update_own-skills')"
                >
                  <multiselect
                    v-model="skill_value[data.item.id]"
                    :options="skillScale"
                    :allow-empty="false"
                    :showLabels="false"
                  />
                </b-form>
              </template>
              <template v-slot:cell(Actions)="data">
                <div class="d-flex">
                  <b-button
                    variant="secondary"
                    class="button btn-icon"
                    @click="editSkill(data.item.id)"
                  >
                  <span class="material-icons">
                    create
                  </span>
                  </b-button>
                  <b-button
                    v-if="$can('delete-skills') || $can('delete_own-skills')"
                    variant="secondary"
                    class="button btn-icon ml-1"
                    @click="detachSkill($event, data.item.id)"
                  >
                    <span class="material-icons">
                      delete
                    </span>
                  </b-button>
                </div>
              </template>
            </b-table>
            <table class="table b-table b-table-fixed mb-0">
              <tbody>
                <tr>
                  <td>
                    <multiselect
                      v-model="newSkill.skill"
                      :options="skills"
                      :allow-empty="false"
                      :showLabels="false"
                      label="name"
                      track-by="id"
                    />
                  </td>
                  <td>
                    <multiselect
                      v-model="newSkill.scale"
                      :options="skillScale"
                      :allow-empty="false"
                      :showLabels="false"
                    />
                  </td>
                  <td class="actions-column">
                    <b-button
                      variant="secondary"
                      class="button btn-icon"
                      @click="addSkill"
                    >
                      <span class="material-icons">
                        save
                      </span>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            variant="primary"
            class="button"
            @click.prevent="cancel"
          >
            Close
          </b-button>
        </template>
      </b-modal>

      <div v-if="$can('read_all-skills') || $can('read_own-skills')">
        <div class="user-skills__title">Skills</div>
        <div class="user-skills__body">
          <div class="user-skills__list">
            <div class="user-skills__item" v-for="skill in userSkills" :key="skill.id">
              <div class="user-skills-chips">
                {{ skill.name }} {{ skill.value }}
              </div>
            </div>
          </div>
          <div class="user-skills__controls">
            <b-button
              variant="secondary"
              class="button"
              v-if="$can('create-skills') || $can('create_own-skills')"
              @click.prevent="setVisibleEditSkillsModal(true)"
            >
              Update skills
            </b-button>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import Preloader from '@components/Preloader.vue'
export default {
  name: 'UserSkills',
  components: { Preloader },
  data () {
    return {
      editSkills: {
        showModal: false
      },
      loading: false,
      userId: null,
      skill_value: [],

      userSkills: [],
      skills: [],

      skill: [],
      form: {
        user_id: '',
        skill_id: 0,
        skill_value: 1
      },
      fieldsSkill: [
        {
          label: 'Name',
          key: 'name'
        },
        {
          label: 'Assessment',
          key: 'value'
        },
        {
          label: 'Actions',
          key: 'Actions',
          class: 'actions-column'
        }
      ],
      skillScale: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      newSkill: {
        skill: null,
        scale: 1
      }
    }
  },
  methods: {
    setVisibleEditSkillsModal (status) {
      this.editSkills.showModal = status
    },
    editSkill (skillId) {
      this.form.user_id = this.userId
      this.form.skill_id = skillId
      this.form.skill_value = this.skill_value[skillId]
      this.attachSkill('updated')
    },
    detachSkill (e, skillId) {
      this.loading = true
      this.axios.post(
        `/api/skill/detach`,
        {
          user_id: this.userId,
          skill_id: skillId
        },
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(() => {
        this.cleatForm()
        this.userSkills = this.userSkills.filter(item => item.id !== skillId)
        this.$snotify.success('Skill successfully deleted', 'Success', this.$store.state.snotify)
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    addSkill () {
      if (!this.newSkill.skill) {
        return this.$snotify.error('Skill is empty', 'Error', this.$store.state.snotify)
      }

      this.form.user_id = this.userId
      this.form.skill_id = this.newSkill.skill.id
      this.form.skill_value = this.newSkill.scale

      this.attachSkill('added')
    },
    clearNewSkill () {
      this.newSkill = {
        skill: null,
        scale: 1
      }
    },
    attachSkill (action) {
      this.loading = true
      this.axios.post(
        `/api/skill/attach`,
        this.form,
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        this.cleatForm()
        this.clearNewSkill()
        this.getUserSkills()
        if (response.status === 200) {
          this.$snotify.success('Skill successfully ' + action, 'Success', this.$store.state.snotify)
        }
      }).catch(err => {
        console.log(err)
        var errors = Object.values(err.response.data.errors)
        for (var i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getSkills () {
      this.axios({
        method: 'get',
        url: '/api/skills',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(response => {
        this.skills = response.data
      }).catch(err => {
        console.log(err)
        var errors = Object.values(err.response.data.errors)
        for (var i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      })
    },
    getUserSkills () {
      this.loading = true
      this.axios({
        method: 'get',
        url: `/api/skills/user/${this.userId}`,
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(response => {
        this.userSkills = response.data
        var arrayValue = []
        this.userSkills.forEach(function (skill) {
          arrayValue[skill.id] = skill.value
        })
        this.skill_value = arrayValue
      }).catch(err => {
        console.log(err)
        var errors = Object.values(err.response.data.errors)
        for (var i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    cleatForm () {
      this.form = {
        user_id: '',
        skill_id: 0,
        skill_value: 1
      }
      this.skill = []
    }
  },
  mounted () {
    if (this.$route.params.id === undefined) {
      this.userId = this._UserInfo.id
    } else {
      this.userId = this.$route.params.id
    }
    this.getUserSkills()
    this.getSkills()
  }
}
</script>

<style lang="scss">

    .width-icon {
        width: 45px;
    }
    .dropdown-toggle::after {
     content: none;
    }
    .v-select {
     color: #495057;
     background-color: #fff;
     border-color: #80bdff;
     outline: 0;
    }
    .v-select .dropdown-toggle {
     height: 39px;
    }
    .v-select input[type="search"], .v-select .selected-tag {
     margin: 0;
    }
    .v-select .vs__actions {
     padding: 0px 6px 4px 3px;
    }
    .v-select .dropdown-toggle .clear {
     margin-top: 5px;
    }
  .actions-column{
    width: 90px;
    text-align: right;
  }
</style>
